import { createAction, props } from '@ngrx/store';
import {Role} from "../../../shared/models/role.model";
import {RolePermission} from "../../../shared/models/role-permission.model";

export const loadRoles = createAction('[Roles Data Access] Load Roles');
export const loadRolesSuccess = createAction(
  '[Role Data Access] Roles Load Success',
  props<{ roles: Role[] }>()
);

export const loadRolesFailure = createAction(
  '[Role Data Access] Roles Load Failure',
  props<{ error: string }>()
);

export const addRole = createAction(
  '[Role Component] Add Roles',
  props<{ role: Role }>()
);

export const addRoleSuccess = createAction(
  '[Role Data Access] Roles Add Success',
  props<{ role: Role, successMessage: string }>()
);

export const addRoleFailure = createAction(
  '[Role Data Access] Roles Add Failure',
  props<{ error: string }>()
);

export const modifyRole = createAction(
  '[Role Component] Modify Roles',
  props<{ role: Role }>()
);

export const modifyRoleSuccess = createAction(
  '[Role Data Access] Roles Modify Success',
  props<{ role: Role, successMessage: string }>()
);

export const modifyRoleFailure = createAction(
  '[Role Data Access] Roles Modify Failure',
  props<{ error: string }>()
);

export const removeRole = createAction(
  '[Role Component] Remove Role',
  props<{ roleId: string }>()
);

export const removeRoleSuccess = createAction(
  '[Role Data Access] Role Remove Success',
  props<{ roleId: string, successMessage: string }>()
);

export const removeRoleFailure = createAction(
  '[Role Data Access] Role Remove Failure',
  props<{ error: string }>()
);

export const setSelectedRole =
  createAction('[Role Component] SetSelectedRole',
    props<{selectedRoleId: string}>()
  );

export const setSelectedRoleSuccess =
  createAction('[Role Component] SetSelectedRole Success',
    props<{selectedRole: Role | null}>()
  );

export const setSelectedRoleFailure =
  createAction('[Role Component] SetSelectedRole Failure',
    props<{error: string}>()
  );

export const addRolePermission = createAction(
  '[RolePermission Component] Add RolePermission',
  props<{ rolePermission: RolePermission }>()
);

export const addRolePermissionSuccess = createAction(
  '[RolePermission Data Access] RolePermissions Add Success',
  props<{ rolePermission: RolePermission, successMessage: string }>()
);

export const addRolePermissionFailure = createAction(
  '[RolePermission Data Access] RolePermissions Add Failure',
  props<{ error: string }>()
);

export const addBulkRolePermission = createAction(
  '[RolePermission Component] Add BulkRolePermission',
  props<{ rolePermissions: RolePermission[] }>()
);

export const addBulkRolePermissionSuccess = createAction(
  '[RolePermission Data Access] BulkRolePermission Add Success',
  props<{ rolePermissions: RolePermission[], successMessage: string }>()
);

export const addBulkRolePermissionFailure = createAction(
  '[RolePermission Data Access] BulkRolePermission Add Failure',
  props<{ error: string }>()
);

export const modifyRolePermission = createAction(
  '[RolePermission Component] Modify RolePermission',
  props<{ rolePermission: RolePermission }>()
);

export const modifyRolePermissionSuccess = createAction(
  '[RolePermission Data Access] RolePermission Modify Success',
  props<{ rolePermission: RolePermission, successMessage: string }>()
);

export const modifyRolePermissionFailure = createAction(
  '[RolePermission Data Access] RolePermission Modify Failure',
  props<{ error: string }>()
);

export const removeRolePermission = createAction(
  '[RolePermission Component] Remove RolePermission',
  props<{ rolePermissionId: string }>()
);

export const removeRolePermissionSuccess = createAction(
  '[RolePermission Data Access] RolePermission Remove Success',
  props<{ rolePermissionId: string, successMessage: string }>()
);

export const removeRolePermissionFailure = createAction(
  '[RolePermission Data Access] RolePermission Remove Failure',
  props<{ error: string }>()
);

export const removeBulkRolePermission = createAction(
  '[RolePermission Component] Remove RolePermissionBulk',
  props<{ rolePermissionIds: string[] }>()
);

export const removeBulkRolePermissionSuccess = createAction(
  '[RolePermission Data Access] BulkRolePermission Remove Success',
  props<{ rolePermissionIds: string[], successMessage: string }>()
);

export const removeBulkRolePermissionFailure = createAction(
  '[RolePermission Data Access] BulkRolePermission Remove Failure',
  props<{ error: string }>()
);
